
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import Select from 'react-select';
import {baseUrl, limit} from "../../../comman/config";
import { can } from "../../../comman/permissions";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import Loader from '../../../components/Loader';
import { ItemNameStacked } from '../../../components/ItemName';
import { menuAboveTable } from "../../../comman/selectMenu";

function List() {

    // Recipe Planning opens this screen for the item and maharaj whose panel the "Recipe Master"
    // button was pressed on. It opens in a new tab, which carries no router state, so the two ids
    // travel in the query string and the filters below are set from them once their lists are in.
    const linkParams = new URLSearchParams(useLocation().search);
    const linkedItem = linkParams.get('item');
    const linkedMaharaj = linkParams.get('maharaj');

    const [receipeList, setReceipeList] = useState([]);
    const [filteredList, setFilteredList] = useState([]);
    const [item, setItem] = useState([]);
    const [maharaj, setMharaj] = useState([]);
    const [category, setCategory] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [maharajList, setMaharajList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    // Enable/disable is an admin's, delete is the superadmin's alone. Both are checked in the
    // controller too -- hiding a button is presentation, not permission.
    const role = String(localStorage.getItem('userRole'));
    // Which buttons this user gets is Role Master's call now, not a role number's -- see
    // comman/permissions.js. `role` is still read because it is what the delete and enable
    // endpoints are told to check against.
    const canDisable = can('disable');
    const canActivate = can('active');
    const canDelete = can('delete');
    // The View action is drawn for everyone: opening this screen at all means holding View on it.
    // Add is Create, and Edit and the Default toggle are Update -- so a user given View and no
    // more gets the recipe to read and nothing to change.
    const canUpdate = can('update');
    const canCreate = can('create');
    const [page, setPage] = useState(1);
    const [totalItem, setTotalItem] = useState(0);
    const [popupOpen, setPopupOpen] = useState(false);
    const [filter, setFilter] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    // Arriving from a link that names a recipe, the Active default would hide it if that recipe
    // happens to be inactive -- and the reader asked for that recipe, not for the active ones.
    const [statusFilter, setStatusFilter] = useState(linkedItem ? { value: '', label: 'All' } : { value: '1', label: 'Active' });

    const navigate = useNavigate();

    useEffect(() => {
        getItemList();
        getMaahrajList();
        getCategoryList();
    }, []);

    useEffect(() => {
        getReceipe();
    }, [item, maharaj, category, statusFilter]);

    useEffect(() => {
        let filterelist;
        if(searchQuery){
            filterelist = receipeList.filter(item => {
                return item.eng_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                       item.item_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                       item.category.toLowerCase().includes(searchQuery.toLowerCase())  ||
                       item?.maharaj?.maharaj_name.toLowerCase().includes(searchQuery.toLowerCase());;
            });
        } else{
            filterelist = receipeList;
        }
        setFilteredList(filterelist);
    }, [searchQuery]);

    const getReceipe = async () => {
        setPopupOpen(true);
        const response = await axios.get(`${baseUrl}/receipe/list?page=${page}&limit=${limit}&item=${item.value}&maharaj=${maharaj.value}&category=${category?.value ?? ''}&status=${statusFilter?.value ?? ''}`);
        setPopupOpen(false);
        setReceipeList(response.data.data);
        setFilteredList(response.data.data);
        setTotalItem(response.data.totalItem);
    }

    const handleToggleStatus = async (item) => {
        try {
            const response = await axios.put(`${baseUrl}/receipe/toggle`, {
                menu_item_id: item.id,
                maharaj_id: item.maharaj?.id,
                status: item.recipe_status,
                role
            });
            if (response.data.status) {
                const newStatus = response.data.new_status;
                const updater = (list) => list.map(r =>
                    r.id === item.id && r.maharaj?.id === item.maharaj?.id
                        ? { ...r, recipe_status: newStatus }
                        : r
                );
                setReceipeList(prev => updater(prev));
                setFilteredList(prev => updater(prev));
            }
        } catch (error) {
            console.error('Toggle failed:', error);
        }
    };

    // Only one recipe of an item can be its default, so the server clears the item's other
    // recipes when it sets one. The list mirrors that: every row of the same item is rewritten,
    // not just the one clicked, or a second row would go on showing a default it no longer holds.
    const handleToggleDefault = async (row) => {
        try {
            const makeDefault = row.is_default != 1;
            const response = await axios.put(`${baseUrl}/receipe/default`, {
                menu_item_id: row.id,
                maharaj_id: makeDefault ? row.maharaj?.id : null,
            });
            if (response.data.status) {
                const updater = (list) => list.map(r =>
                    r.id !== row.id
                        ? r
                        : { ...r, is_default: (makeDefault && r.maharaj?.id === row.maharaj?.id) ? 1 : 0 }
                );
                setReceipeList(prev => updater(prev));
                setFilteredList(prev => updater(prev));
            }
        } catch (error) {
            console.error('Default toggle failed:', error);
        }
    };

    // Delete removes the recipe and its process steps, and there is no undo -- so the wording says
    // so, and points at the Status toggle beside it, which is the reversible way to take a recipe
    // out of use.
    const handleDelete = async (row) => {
        const name = `${row.item_name ?? ''}${row.eng_name ? ` (${row.eng_name})` : ''}`.trim();
        const maharajName = row.maharaj?.maharaj_name ?? '-';
        if (!window.confirm(`Permanently DELETE the recipe for ${name} by ${maharajName}? Making it Inactive is reversible; this is not.`)) return;
        try {
            await axios.delete(`${baseUrl}/receipe/destroy`, {
                data: { menu_item_id: row.id, maharaj_id: row.maharaj?.id, role },
            });
            setReceipeList(prev => prev.filter(r => !(r.id === row.id && r.maharaj?.id === row.maharaj?.id)));
            setFilteredList(prev => prev.filter(r => !(r.id === row.id && r.maharaj?.id === row.maharaj?.id)));
        } catch (error) {
            alert(error?.response?.data?.msg ?? 'Could not delete the recipe.');
        }
    };

    const handelFilterChange= (e) => {
        const { value } = e.target;
        setSearchQuery(value);
    };

    const getItemList = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=item_master&condition=status=1`);
        const itemList = response.data.data;
        setItemList(itemList);
        // A linked id can only become a chip once its row is known -- the box shows a name.
        const linked = itemList.find((i) => String(i.id) === String(linkedItem));
        if (linked) {
            setItem({ value: linked.id, label: `${linked.item_name} ${linked.eng_name ? `(${linked.eng_name})` : ''}` });
        }
    }

    const getCategoryList = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=item_category_master&condition=status=1`);
        setCategoryList(response.data.data);
    }

    const getMaahrajList = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=maharaj_master&condition=status=1`);
        const itemList = response.data.data;
        setMaharajList(itemList);
        const linked = itemList.find((m) => String(m.id) === String(linkedMaharaj));
        if (linked) {
            setMharaj({ value: linked.id, label: linked.maharaj_name });
        }
    }

    const openReceipeitem = async (id, maharaj_id, mode) => {
        const row = receipeList.filter(item => item.id == id && item.maharaj?.id == maharaj_id);
        // The maharaj rides in the query string as well as in the state, so a reload -- or a link
        // copied out of the address bar -- still finds the one recipe rather than the item.
        const maharajParam = maharaj_id ? `?maharaj=${maharaj_id}` : '';
        navigate(`/receipe/${mode}/${btoa(id)}${maharajParam}`, { state: row });
    }

    const handleSelectChange = (selected, name) => {
        if(name === 'item'){
            setItem(selected);
        }else if(name === 'maharaj'){
            setMharaj(selected);
        }else if(name === 'category'){
            setCategory(selected);
        }
    };

    const handleClear = () => {
        setItem("");
        setMharaj("");
        setCategory("");
        setStatusFilter({ value: '1', label: 'Active' });
    }

    return (
        <div className="p-4">
            {popupOpen && <Loader />}
            <div className="flex justify-between items-center py-4 px-6">
                <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Recipe Master</h1>
                <div>
                    {canCreate && <Link to="/receipe/add">
                        <button className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Add Receipe</button>
                    </Link>}
                </div>
            </div>
            <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                <div className="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center pb-4">
                    <div className='m-5'>
                        <Select
                            {...menuAboveTable}
                            classNamePrefix="select"
                            className='basic-multi-select'
                            value={item}
                            name="item"
                            onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'item')}
                            options={itemList.map(item => ({
                                value: item.id,
                                label: `${item.item_name} ${item.eng_name ? `(${item.eng_name})` : ''}`
                            }))}
                            placeholder="Item List"
                            filterOption={(option, inputValue) => {
                                return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                        />
                    </div>
                    <div className='m-5'>
                        <Select
                            {...menuAboveTable}
                            classNamePrefix="select"
                            className='basic-multi-select'
                            value={maharaj}
                            name="maharaj"
                            onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'maharaj')}
                            options={maharajList.map(item => ({
                                value: item.id,
                                label: item.maharaj_name
                            }))}
                            placeholder="Maharaj List"
                            filterOption={(option, inputValue) => {
                                return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                        />
                    </div>
                    <div className='m-5'>
                        {/* The menu item's category. A recipe has none of its own -- it inherits
                            the one on the item it is a recipe for. */}
                        <Select
                            {...menuAboveTable}
                            classNamePrefix="select"
                            className='basic-multi-select'
                            value={category}
                            name="category"
                            onChange={(selectedOptions) => handleSelectChange(selectedOptions, 'category')}
                            options={categoryList.map(item => ({
                                value: item.id,
                                label: `${item.name} ${item.eng_name ? `(${item.eng_name})` : ''}`
                            }))}
                            placeholder="Category"
                            filterOption={(option, inputValue) => {
                                return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                            }}
                        />
                    </div>
                    <div className='m-5'>
                        <Select
                            {...menuAboveTable}
                            classNamePrefix="select"
                            className='basic-multi-select w-36'
                            value={statusFilter}
                            name="status"
                            onChange={(selected) => setStatusFilter(selected)}
                            options={[
                                { value: '', label: 'All' },
                                { value: '1', label: 'Active' },
                                { value: '0', label: 'Inactive' }
                            ]}
                            placeholder="Status"
                            isClearable={false}
                        />
                    </div>
                    <div className='m-5'>
                        <button
                            onClick={handleClear}
                            className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                        >
                            Clear
                        </button>
                    </div>
                </div>

                <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                        <tr>
                            <th scope="col" className="px-6 py-3">Menuitem name</th>
                            <th scope="col" className="px-6 py-3">Category</th>
                            <th scope="col" className="px-6 py-3">Maharaj name</th>
                            <th scope="col" className="px-6 py-3">Default</th>
                            <th scope="col" className="px-6 py-3">Status</th>
                            <th scope="col" className="px-6 py-3">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredList.map((item) => (
                            <tr key={`${item.id} ${item.maharaj?.id}`} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                <th scope="row" className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"><ItemNameStacked item={item} /></th>
                                <td className='px-6 py-4'>{item.category}</td>
                                <td className="px-6 py-4">{item?.maharaj?.maharaj_name ?? "-"}</td>
                                <td className="px-6 py-4">
                                    <button
                                        onClick={() => handleToggleDefault(item)}
                                        disabled={!item.maharaj?.id || !canUpdate}
                                        className={`relative inline-flex items-center h-6 w-11 rounded-full transition-colors focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed ${item.is_default == 1 ? 'bg-blue-500' : 'bg-gray-300'}`}
                                        title={!canUpdate
                                            ? 'You have View rights on this screen'
                                            : (item.is_default == 1 ? 'Click to remove as default' : 'Click to make default')}
                                    >
                                        <span className={`inline-block w-4 h-4 bg-white rounded-full shadow transform transition-transform ${item.is_default == 1 ? 'translate-x-6' : 'translate-x-1'}`} />
                                    </button>
                                </td>
                                <td className="px-6 py-4">
                                    <button
                                        onClick={() => handleToggleStatus(item)}
                                        disabled={item.recipe_status == 1 ? !canDisable : !canActivate}
                                        className={`relative inline-flex items-center h-6 w-11 rounded-full transition-colors focus:outline-none disabled:opacity-40 disabled:cursor-not-allowed ${item.recipe_status == 1 ? 'bg-green-500' : 'bg-gray-300'}`}
                                        title={(item.recipe_status == 1 ? canDisable : canActivate)
                                            ? (item.recipe_status == 1 ? 'Click to Inactive' : 'Click to Active')
                                            : 'Your role is not allowed to change a recipe status'}
                                    >
                                        <span className={`inline-block w-4 h-4 bg-white rounded-full shadow transform transition-transform ${item.recipe_status == 1 ? 'translate-x-6' : 'translate-x-1'}`} />
                                    </button>
                                </td>
                                <td className="px-6 py-4">
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        onClick={() => openReceipeitem(item.id, item?.maharaj?.id, 'view')}
                                        className="px-3 py-1 text-sm bg-gray-600 text-white rounded-md hover:bg-gray-700 focus:outline-none focus:ring focus:ring-gray-200">
                                        View
                                    </button>
                                    {canUpdate && <button
                                        type="button"
                                        onClick={() => openReceipeitem(item.id, item?.maharaj?.id, 'edit')}
                                        className="px-3 py-1 text-sm bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">
                                        Edit
                                    </button>}
                                    {canDelete && <button
                                        type="button"
                                        onClick={() => handleDelete(item)}
                                        className="px-3 py-1 text-sm bg-red-500 text-white rounded-md hover:bg-red-600 focus:outline-none focus:ring focus:ring-red-200">
                                        Delete
                                    </button>}
                                </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default List;
